import { GraphQLClient } from 'graphql-request';
import { print } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** NaiveDate */
  NaiveDate: any;
  /** NaiveDateTime */
  NaiveDateTime: any;
  /** Uuid */
  Uuid: any;
};

export type AdditionalInfoInput = {
  gender?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  desiredStartDate?: Maybe<Scalars['NaiveDate']>;
  languagesSpoken?: Maybe<Array<Scalars['String']>>;
  employmentType?: Maybe<EmploymentType>;
  inputLinkedin?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  experience?: Maybe<Experience>;
  npi?: Maybe<Scalars['String']>;
  bacbCertificationNumber?: Maybe<Scalars['String']>;
  /** List of insurance companies where the candidate is certified */
  insurances?: Maybe<Array<InsuranceStatePair>>;
  /** State in which the candidate lives */
  stateLocation?: Maybe<StateLocation>;
  /** The city where the candidate lives */
  cityLocation?: Maybe<Scalars['String']>;
  isAddressAccurate?: Maybe<Scalars['Boolean']>;
};

export type AdminMutation = {
  __typename?: 'AdminMutation';
  giveAdminAccess: Scalars['Boolean'];
  withdrawAdminAccess: Scalars['Boolean'];
  migrateToGreenhouse: Scalars['String'];
};


export type AdminMutationGiveAdminAccessArgs = {
  emailAddress: Scalars['String'];
};


export type AdminMutationWithdrawAdminAccessArgs = {
  emailAddress: Scalars['String'];
};


export type AdminMutationMigrateToGreenhouseArgs = {
  candidateId: Scalars['Uuid'];
};

export type AdminQuery = {
  __typename?: 'AdminQuery';
  checkAdminAccess: Scalars['Boolean'];
  getAnswers?: Maybe<CandidateAnswers>;
  getGreenhouseLink?: Maybe<Scalars['String']>;
};


export type AdminQueryGetAnswersArgs = {
  candidateId: Scalars['Uuid'];
};


export type AdminQueryGetGreenhouseLinkArgs = {
  candidateId: Scalars['Uuid'];
};

export type Answer = {
  __typename?: 'Answer';
  id?: Maybe<Scalars['Uuid']>;
  formulation?: Maybe<Scalars['String']>;
};

export type Candidate = {
  __typename?: 'Candidate';
  id: Scalars['Uuid'];
  firstName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  level?: Maybe<Level>;
  state?: Maybe<State>;
  priority?: Maybe<Priority>;
  phone?: Maybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  desiredStartDate?: Maybe<Scalars['NaiveDate']>;
  languagesSpoken?: Maybe<Array<Scalars['String']>>;
  employmentType?: Maybe<EmploymentType>;
  experience?: Maybe<Experience>;
  inputLinkedin?: Maybe<Scalars['String']>;
  isAdmin: Scalars['Boolean'];
  /** National Provider Identifier */
  npi?: Maybe<Scalars['String']>;
  /** Behavior Analyst Certification Board Number */
  bacbCertificationNumber?: Maybe<Scalars['String']>;
  appliedTime?: Maybe<Scalars['Float']>;
  /** Is present in greenhouse */
  isPresent: Scalars['Boolean'];
  cityLocation?: Maybe<Scalars['String']>;
  stateLocation?: Maybe<StateLocation>;
  isAddressAccurate?: Maybe<Scalars['Boolean']>;
  isQuizCompleted: Scalars['Boolean'];
};

export type CandidateAnswer = {
  __typename?: 'CandidateAnswer';
  id: Scalars['Uuid'];
  question: Scalars['String'];
  answer: Scalars['String'];
};

export type CandidateAnswers = {
  __typename?: 'CandidateAnswers';
  score: Scalars['Float'];
  allScore: Scalars['Float'];
  questionsAnswers: Array<CandidateAnswer>;
};

export type CandidateAuthInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type CandidateMutation = {
  __typename?: 'CandidateMutation';
  add: Candidate;
  authenticate: UserRole;
  logout: Scalars['Boolean'];
  clarify: Candidate;
  setState: Candidate;
  requestResetPassword: Scalars['Boolean'];
  saveVideoResponse: Scalars['Boolean'];
  setPassword: Scalars['Boolean'];
  changePassword: Scalars['Boolean'];
};


export type CandidateMutationAddArgs = {
  input: CandidateSummaryInput;
};


export type CandidateMutationAuthenticateArgs = {
  input: CandidateAuthInput;
};


export type CandidateMutationClarifyArgs = {
  input: AdditionalInfoInput;
};


export type CandidateMutationSetStateArgs = {
  input: State;
};


export type CandidateMutationRequestResetPasswordArgs = {
  emailAddress: Scalars['String'];
};


export type CandidateMutationSaveVideoResponseArgs = {
  input: VideoResponseInput;
};


export type CandidateMutationSetPasswordArgs = {
  input: SetPasswordInput;
};


export type CandidateMutationChangePasswordArgs = {
  input: ChangePasswordInput;
};

export type CandidateQuery = {
  __typename?: 'CandidateQuery';
  get: Candidate;
  getByToken: Candidate;
  getCvFileInfo?: Maybe<FileInfo>;
};


export type CandidateQueryGetArgs = {
  candidateId?: Maybe<Scalars['Uuid']>;
};


export type CandidateQueryGetByTokenArgs = {
  token: Scalars['String'];
};

export type CandidateSummary = {
  __typename?: 'CandidateSummary';
  id: Scalars['Uuid'];
  name: Scalars['String'];
  level?: Maybe<Level>;
  zipcode?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  stateLocation?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  inputLinkedin?: Maybe<Scalars['String']>;
  experience?: Maybe<Experience>;
  priority?: Maybe<Priority>;
};

export type CandidateSummaryInput = {
  firstName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  emailAddress: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  zipcode: Scalars['String'];
  level: Level;
};

export type Candidates = {
  __typename?: 'Candidates';
  candidates: Array<CandidateSummary>;
  count: Scalars['Int'];
};

export type CandidatesQuery = {
  __typename?: 'CandidatesQuery';
  get: Candidates;
};


export type CandidatesQueryGetArgs = {
  input: CandidatesRequest;
};

export type CandidatesRequest = {
  filter?: Maybe<Filter>;
  prioritizer?: Maybe<Prioritizer>;
  sorter?: Maybe<Sorter>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type ChangePasswordInput = {
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

export type Diploma = {
  __typename?: 'Diploma';
  fileMetadata?: Maybe<FileMetadata>;
  degree?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['NaiveDate']>;
  expirationDate?: Maybe<Scalars['NaiveDate']>;
};

export type DiplomaMetadata = {
  degree: Scalars['String'];
};

export enum DocumentType {
  CaqhApplication = 'CAQH_APPLICATION',
  NpiNumber = 'NPI_NUMBER',
  MedicaidId = 'MEDICAID_ID',
  ProviderCertificationNumber = 'PROVIDER_CERTIFICATION_NUMBER',
  BcbaLicenseNumber = 'BCBA_LICENSE_NUMBER',
  Resume = 'RESUME',
  CandidateResume = 'CANDIDATE_RESUME',
  RbtCertificate = 'RBT_CERTIFICATE',
  BcbaCertificate = 'BCBA_CERTIFICATE',
  DriversLicense = 'DRIVERS_LICENSE',
  ProofOfCarInsurance = 'PROOF_OF_CAR_INSURANCE',
  Diploma = 'DIPLOMA',
  CprCertificate = 'CPR_CERTIFICATE',
  TuberculosisTest = 'TUBERCULOSIS_TEST',
  StateLicense = 'STATE_LICENSE',
  SupervisionCertificate = 'SUPERVISION_CERTIFICATE',
  Passport = 'PASSPORT',
  SocialSecurityCard = 'SOCIAL_SECURITY_CARD',
  BirthCertificate = 'BIRTH_CERTIFICATE',
  Headshot = 'HEADSHOT',
  CovidWaiverSign = 'COVID_WAIVER_SIGN',
  ConfidentialityAgreementSign = 'CONFIDENTIALITY_AGREEMENT_SIGN',
  EquipmentExitAuthSign = 'EQUIPMENT_EXIT_AUTH_SIGN',
  AcceptableAssetsUseSign = 'ACCEPTABLE_ASSETS_USE_SIGN',
  SignaturePageSign = 'SIGNATURE_PAGE_SIGN',
  AuditTrailSign = 'AUDIT_TRAIL_SIGN'
}

export type DocumentsMutation = {
  __typename?: 'DocumentsMutation';
  setDocumentDates: Scalars['Boolean'];
  setDiplomaDegree: Scalars['Boolean'];
};


export type DocumentsMutationSetDocumentDatesArgs = {
  input: Metadata;
};


export type DocumentsMutationSetDiplomaDegreeArgs = {
  input: DiplomaMetadata;
};

export type DocumentsQuery = {
  __typename?: 'DocumentsQuery';
  getDocuments: Array<ProviderDocument>;
  getDiploma: Diploma;
};

export type DocumentsStatus = {
  __typename?: 'DocumentsStatus';
  confidentialityAgreementSignStatus: SignStatus;
  covid19WaiverSignStatus: SignStatus;
  equipmentExitAuthSignStatus: SignStatus;
  acceptableUseAssetsSignStatus: SignStatus;
};

export enum EmploymentType {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME'
}

/** Experience of candidate */
export enum Experience {
  ExperienceLessThanOneYear = 'EXPERIENCE_LESS_THAN_ONE_YEAR',
  ExperienceOneTwoYear = 'EXPERIENCE_ONE_TWO_YEAR',
  ExperienceThreeFourYear = 'EXPERIENCE_THREE_FOUR_YEAR',
  ExperienceFivePlusYear = 'EXPERIENCE_FIVE_PLUS_YEAR'
}

export type FileInfo = {
  __typename?: 'FileInfo';
  candidateId: Scalars['Uuid'];
  name: Scalars['String'];
  contentType: Scalars['String'];
};

export type FileMetadata = {
  __typename?: 'FileMetadata';
  fileId: Scalars['Uuid'];
  filename: Scalars['String'];
  contentType: Scalars['String'];
  bytesSize: Scalars['Int'];
};

export type Filter = {
  name?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  level?: Maybe<Level>;
};

export type HellosignQuery = {
  __typename?: 'HellosignQuery';
  getSignUrl: Scalars['String'];
  getSignStatus: DocumentsStatus;
};

export type InsuranceInput = {
  isCredentialedOutsideResidenceState: Scalars['Boolean'];
  insurances: Array<InsuranceStatePair>;
};

export type InsuranceMutation = {
  __typename?: 'InsuranceMutation';
  updateInsurances: Scalars['Boolean'];
};


export type InsuranceMutationUpdateInsurancesArgs = {
  input: InsuranceInput;
};

export type InsuranceQuery = {
  __typename?: 'InsuranceQuery';
  isCredentialedOutsideResidenceState: Scalars['Boolean'];
  getInsurances: Array<InsuranceResponse>;
};

export type InsuranceResponse = {
  __typename?: 'InsuranceResponse';
  title: Scalars['String'];
  state: StateLocation;
};

export type InsuranceStatePair = {
  insurance: Scalars['String'];
  state: StateLocation;
};

export enum Level {
  LevelRbt = 'LEVEL_RBT',
  LevelBcba = 'LEVEL_BCBA',
  LevelBtToRbt = 'LEVEL_BT_TO_RBT'
}

export type Metadata = {
  documentType: DocumentType;
  effectiveDate?: Maybe<Scalars['NaiveDate']>;
  expirationDate?: Maybe<Scalars['NaiveDate']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  candidates: CandidateMutation;
  quiz: QuizMutation;
  admin: AdminMutation;
  peopleManagment: PeopleManagementMutation;
  onboarding: OnboardingMutation;
  documents: DocumentsMutation;
  insurances: InsuranceMutation;
};



export type OnboardingMutation = {
  __typename?: 'OnboardingMutation';
  /** Set status for task */
  setTaskStatus: Status;
  /** Set current status for provider from context */
  setCurrentTask: Task;
};


export type OnboardingMutationSetTaskStatusArgs = {
  input: TaskInput;
};


export type OnboardingMutationSetCurrentTaskArgs = {
  taskId: Scalars['Uuid'];
};

export type OnboardingQuery = {
  __typename?: 'OnboardingQuery';
  /** Get all tasks for provider from context */
  getAllTasksStatuses: Array<Task>;
  /** Get current task for provider from context */
  getCurrentTask?: Maybe<Task>;
};

export type PeopleManagementMutation = {
  __typename?: 'PeopleManagementMutation';
  requestTimeOff: TimeOffRequest;
};


export type PeopleManagementMutationRequestTimeOffArgs = {
  input: TimeOffRequestInput;
};

export type PeopleManagementQuery = {
  __typename?: 'PeopleManagementQuery';
  getRequestedTimeOff: Array<TimeOffRequest>;
  getTimeOffRequestsTypes: Array<TimeOffType>;
};


export type PeopleManagementQueryGetRequestedTimeOffArgs = {
  input: RequestsInput;
};

export type Prioritizer = {
  zipcodes?: Maybe<Array<Scalars['String']>>;
  cities?: Maybe<Array<Scalars['String']>>;
  states?: Maybe<Array<Scalars['String']>>;
};

export enum Priority {
  PriorityOne = 'PRIORITY_ONE',
  PriorityTwo = 'PRIORITY_TWO',
  PriorityThree = 'PRIORITY_THREE',
  PriorityNone = 'PRIORITY_NONE'
}

export type ProviderDocument = {
  __typename?: 'ProviderDocument';
  documentType?: Maybe<DocumentType>;
  isDataPresent: Scalars['Boolean'];
  fileMetadata?: Maybe<FileMetadata>;
  effectiveDate?: Maybe<Scalars['NaiveDate']>;
  expirationDate?: Maybe<Scalars['NaiveDate']>;
};

export type Query = {
  __typename?: 'Query';
  admin: AdminQuery;
  candidates: CandidatesQuery;
  candidate: CandidateQuery;
  quiz: QuizQuery;
  peopleManagment: PeopleManagementQuery;
  onboarding: OnboardingQuery;
  documents: DocumentsQuery;
  hellosign: HellosignQuery;
  insurances: InsuranceQuery;
};

export type QuestionAnswersInput = {
  id: Scalars['Uuid'];
  answers?: Maybe<Array<Scalars['Uuid']>>;
  freeAnswer?: Maybe<Scalars['String']>;
};

export type QuestionFormulation = {
  __typename?: 'QuestionFormulation';
  id: Scalars['Uuid'];
  index: Scalars['Int'];
  formulation: Scalars['String'];
  isFreeForm: Scalars['Boolean'];
  answers?: Maybe<Array<Answer>>;
};

export type QuestionsGroup = {
  __typename?: 'QuestionsGroup';
  prefix?: Maybe<Scalars['String']>;
  questions: Array<QuestionFormulation>;
};

export type QuizCandidateAnswer = {
  __typename?: 'QuizCandidateAnswer';
  questionId: Scalars['Uuid'];
  answersIds?: Maybe<Array<Scalars['Uuid']>>;
  freeFormAnswer?: Maybe<Scalars['String']>;
};

export type QuizMutation = {
  __typename?: 'QuizMutation';
  resolve: Candidate;
};


export type QuizMutationResolveArgs = {
  level?: Maybe<Level>;
  input: Array<QuestionAnswersInput>;
};

export type QuizQuery = {
  __typename?: 'QuizQuery';
  get: Array<QuestionsGroup>;
  getAnswers: Array<QuizCandidateAnswer>;
};


export type QuizQueryGetArgs = {
  level?: Maybe<Level>;
};

/** Request all time off requests for this period */
export type RequestsInput = {
  start: Scalars['NaiveDate'];
  end: Scalars['NaiveDate'];
};

export type SetPasswordInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export enum SignStatus {
  NotStarted = 'NOT_STARTED',
  Done = 'DONE'
}

export enum Sorter {
  Priority = 'PRIORITY',
  PriorityReverse = 'PRIORITY_REVERSE',
  City = 'CITY',
  CityReverse = 'CITY_REVERSE',
  State = 'STATE',
  StateReverse = 'STATE_REVERSE',
  Experience = 'EXPERIENCE',
  ExperienceReverse = 'EXPERIENCE_REVERSE'
}

export enum State {
  Welcome = 'WELCOME',
  PersonalInfo = 'PERSONAL_INFO',
  Availability = 'AVAILABILITY',
  Quiz = 'QUIZ',
  VideoResponses = 'VIDEO_RESPONSES',
  Done = 'DONE'
}

export enum StateLocation {
  Alabama = 'ALABAMA',
  Alaska = 'ALASKA',
  AmericanSamoa = 'AMERICAN_SAMOA',
  Arizona = 'ARIZONA',
  Arkansas = 'ARKANSAS',
  California = 'CALIFORNIA',
  Colorado = 'COLORADO',
  Connecticut = 'CONNECTICUT',
  Delaware = 'DELAWARE',
  DistrictOfColumbia = 'DISTRICT_OF_COLUMBIA',
  Florida = 'FLORIDA',
  Georgia = 'GEORGIA',
  Guam = 'GUAM',
  Hawaii = 'HAWAII',
  Idaho = 'IDAHO',
  Illinois = 'ILLINOIS',
  Indiana = 'INDIANA',
  Iowa = 'IOWA',
  Kansas = 'KANSAS',
  Kentucky = 'KENTUCKY',
  Louisiana = 'LOUISIANA',
  Maine = 'MAINE',
  Maryland = 'MARYLAND',
  Massachusetts = 'MASSACHUSETTS',
  Michigan = 'MICHIGAN',
  Minnesota = 'MINNESOTA',
  Mississippi = 'MISSISSIPPI',
  Missouri = 'MISSOURI',
  Montana = 'MONTANA',
  Nebraska = 'NEBRASKA',
  Nevada = 'NEVADA',
  NewHampshire = 'NEW_HAMPSHIRE',
  NewJersey = 'NEW_JERSEY',
  NewMexico = 'NEW_MEXICO',
  NewYork = 'NEW_YORK',
  NorthCarolina = 'NORTH_CAROLINA',
  NorthDakota = 'NORTH_DAKOTA',
  NorthernMarianaIs = 'NORTHERN_MARIANA_IS',
  Ohio = 'OHIO',
  Oklahoma = 'OKLAHOMA',
  Oregon = 'OREGON',
  Pennsylvania = 'PENNSYLVANIA',
  PuertoRico = 'PUERTO_RICO',
  RhodeIsland = 'RHODE_ISLAND',
  SouthCarolina = 'SOUTH_CAROLINA',
  SouthDakota = 'SOUTH_DAKOTA',
  Tennessee = 'TENNESSEE',
  Texas = 'TEXAS',
  Utah = 'UTAH',
  Vermont = 'VERMONT',
  Virginia = 'VIRGINIA',
  VirginIslands = 'VIRGIN_ISLANDS',
  Washington = 'WASHINGTON',
  WestVirginia = 'WEST_VIRGINIA',
  Wisconsin = 'WISCONSIN',
  Wyoming = 'WYOMING'
}

export enum Status {
  TaskStatusOpen = 'TASK_STATUS_OPEN',
  TaskStatusInProgress = 'TASK_STATUS_IN_PROGRESS',
  TaskStatusDone = 'TASK_STATUS_DONE',
  TaskStatusReopened = 'TASK_STATUS_REOPENED'
}

export type Task = {
  __typename?: 'Task';
  taskId: Scalars['Uuid'];
  title: Scalars['String'];
  status: Status;
  taskIndex: Scalars['Int'];
  deadline: Scalars['NaiveDateTime'];
  timeLeft: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
};

export type TaskInput = {
  taskId: Scalars['Uuid'];
  status: Status;
};

export type TimeOffRequest = {
  __typename?: 'TimeOffRequest';
  startDate: Scalars['NaiveDate'];
  endDate: Scalars['NaiveDate'];
  timeOffTypeId: Scalars['Int'];
  status: TimeOffStatus;
};

export type TimeOffRequestInput = {
  startDate: Scalars['NaiveDate'];
  endDate: Scalars['NaiveDate'];
  description?: Maybe<Scalars['String']>;
  timeOffTypeId: Scalars['Int'];
  amount: Scalars['Int'];
};

export enum TimeOffStatus {
  TimeOffStatusApproved = 'TIME_OFF_STATUS_APPROVED',
  TimeOffStatusPendingApproval = 'TIME_OFF_STATUS_PENDING_APPROVAL',
  TimeOffStatusRejected = 'TIME_OFF_STATUS_REJECTED'
}

export type TimeOffType = {
  __typename?: 'TimeOffType';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum UserRole {
  Admin = 'ADMIN',
  CandidateBcba = 'CANDIDATE_BCBA',
  CandidateRbt = 'CANDIDATE_RBT',
  CandidateBtToRbt = 'CANDIDATE_BT_TO_RBT',
  Bcba = 'BCBA',
  Rbt = 'RBT',
  BtToRbt = 'BT_TO_RBT'
}


export type VideoResponseInput = {
  contactId: Scalars['String'];
  interactionLink: Scalars['String'];
};

export type RegisterMutationVariables = Exact<{
  input: CandidateSummaryInput;
}>;


export type RegisterMutation = (
  { __typename?: 'Mutation' }
  & { candidates: (
    { __typename?: 'CandidateMutation' }
    & { add: (
      { __typename?: 'Candidate' }
      & Pick<Candidate, 'id'>
    ) }
  ) }
);


export const RegisterDocument = gql`
    mutation Register($input: CandidateSummaryInput!) {
  candidates {
    add(input: $input) {
      id
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: () => Promise<T>) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = sdkFunction => sdkFunction();
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    Register(variables: RegisterMutationVariables, requestHeaders?: Headers): Promise<RegisterMutation> {
      return withWrapper(() => client.request<RegisterMutation>(print(RegisterDocument), variables, requestHeaders));
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;